import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import { Link } from "react-router";
import DropTarget from "../components/dropTarget.react";
import MenuItemDragAndDrop from "./menuItemDragAndDrop.react";

export default class Menu extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.loadMenuData();
  }

  loadMenuData = () => {
    const {
      pages: { pages: { meta: pagesMeta } },
      actions,
      notificationSystem,
      params: { placeholder },
      locales: { locales: { defaultLocale } },
      menusTranslations: { menusTranslations: { entities: menusTranslations } },
      menuItems: { menuItems: { entities: menuItems } }
    } = this.props;

    actions
      .getPages(pagesMeta)
      .then(({ error: pagesError, payload: pagesPayload }) => {
        if (pagesError) {
          addNotificationsForInvalidFields(pagesPayload, notificationSystem);
        } else {
          actions.getMenu(placeholder).then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            } else {
              const menuTranslationUID =
                payload.entities.menus[payload.result].menuTranslations[
                  defaultLocale
                ].uid;
              actions
                .getMenusTranslationsMenuItems(menuTranslationUID)
                .then(({ error, payload, meta }) => {
                  if (error) {
                    addNotificationsForInvalidFields(
                      payload,
                      notificationSystem
                    );
                  } else {
                    let menuItems = [];
                    payload.result.forEach(function(item, index) {
                      let menuItem = undefined;
                      pagesPayload.result.pages.forEach(function(page, index) {
                        if (
                          `/${pagesPayload.entities.pages[page]
                            .pageTranslations[defaultLocale].slug}` ===
                          payload.entities.menuItems[item].value
                        ) {
                          actions.setEntityField(
                            "menuItems",
                            payload.entities.menuItems[item].uid,
                            "value",
                            `page:${pagesPayload.entities.pages[page]
                              .pageTranslations[defaultLocale].uid}`
                          );
                          menuItem = payload.entities.menuItems[item];
                          menuItem.value = `page:${pagesPayload.entities.pages[
                            page
                          ].pageTranslations[defaultLocale].uid}`;
                        }
                      });
                      if (menuItem) {
                        menuItems.push(menuItem);
                      } else {
                        menuItems.push(payload.entities.menuItems[item]);
                      }
                    });
                    menuItems.sort(function(a, b) {
                      return parseFloat(a.left) - parseFloat(b.left);
                    });
                    const menu = this.prepareMenuData(menuItems, 0);
                    actions.setMenuTranslationDataObject(
                      menuTranslationUID,
                      menu
                    );
                  }
                });
            }
          });
        }
      });
  };

  componentDidUpdate(prevProps) {
    const {
      actions,
      menuItems: { menuItems: { entities: menuItems } },
      pageTranslations: { pageTranslations: { entities: pageTranslations } },
      locales: { locales: { defaultLocale } }
    } = this.props;
    const { menuItems: { menuItems: { entities: prevMenuItems } } } = prevProps;
    menuItems.forEach(function(item, index) {
      pageTranslations.forEach(function(pageItem, pageIndex) {
        if (
          `/${pageItem.getIn([defaultLocale, "slug"])}` === item.get("value")
        ) {
          actions.setEntityField(
            "menuItems",
            index,
            "value",
            `page:${pageItem.getIn([defaultLocale, "uid"])}`
          );
        }
      });
    });
  }

  prepareMenuData = (menuItems, depth) => {
    const self = this;
    let right = 0;
    let submenu = [];
    let menu = [];
    menuItems.forEach(function(item, index) {
      if (item.right - item.left === 1 && item.depth === depth) {
        menu = menu.concat(item);
      } else if (item.depth === depth) {
        menu = menu.concat(item);
        right = item.right;
      }
      if (item.left < right && item.depth !== depth) {
        submenu = submenu.concat(item);
      } else if (submenu.length > 0) {
        menu[menu.length - 2].submenu = self.prepareMenuData(
          submenu,
          depth + 1
        );
        submenu = [];
      }
    });

    if (submenu.length > 0) {
      menu[menu.length - 2].submenu = self.prepareMenuData(submenu, depth + 1);
      submenu = [];
    }

    return menu;
  };

  generateMenuHTML = (menu, depth, uid) => {
    const {
      settings: { draggingItemUID, hoveringItemUID },
      actions,
      menuItems: {
        menuItems: {
          entities: menuItems,
          isRemoveModalVisible,
          isEditModalVisible,
          isAddModalVisible
        }
      },
      notificationSystem,
      menusTranslations: {
        forms: { createMenusTranslationMenuItems: form },
        menusTranslations: { entities: menusTranslations }
      },
      pages: { pages: { entities: pages } },
      locales: { locales: { defaultLocale } }
    } = this.props;
    const self = this;
    return menu.map(function(item, index) {
      if (item.submenu) {
        return (
          <div key={index} className="col-xs-12">
            <MenuItemDragAndDrop
              actions={actions}
              notificationSystem={notificationSystem}
              menusTranslations={menusTranslations}
              draggingItemUID={draggingItemUID}
              hoveringItemUID={hoveringItemUID}
              form={form}
              menuItems={menuItems}
              menuItemUID={item.uid}
              uid={uid}
              actions={actions}
              isRemoveModalVisible={isRemoveModalVisible}
              isEditModalVisible={isEditModalVisible}
              isAddModalVisible={isAddModalVisible}
              notificationSystem={notificationSystem}
              pages={pages}
              defaultLocale={defaultLocale}
              updateAction={self.loadMenuData}
            />
            {self.generateMenuHTML(item.submenu, depth + 1, uid)}
          </div>
        );
      }
      return (
        <div key={index} className="col-xs-12">
          <MenuItemDragAndDrop
            actions={actions}
            notificationSystem={notificationSystem}
            menusTranslations={menusTranslations}
            draggingItemUID={draggingItemUID}
            hoveringItemUID={hoveringItemUID}
            form={form}
            menuItems={menuItems}
            menuItemUID={item.uid}
            uid={uid}
            actions={actions}
            isRemoveModalVisible={isRemoveModalVisible}
            isEditModalVisible={isEditModalVisible}
            isAddModalVisible={isAddModalVisible}
            notificationSystem={notificationSystem}
            pages={pages}
            defaultLocale={defaultLocale}
            updateAction={self.loadMenuData}
          />
        </div>
      );
    });
  };

  generateMenu = () => {
    const {
      menus: { menus: { entities: menus } },
      menusTranslations: { menusTranslations: { entities: menusTranslations } },
      locales: { locales: { defaultLocale } },
      params: { placeholder }
    } = this.props;
    const menu = menusTranslations.getIn([
      menus.getIn([placeholder, "menuTranslations", defaultLocale, "uid"]),
      "dataObject"
    ]);
    return menu
      ? this.generateMenuHTML(
          menu,
          0,
          menus.getIn([placeholder, "menuTranslations", defaultLocale, "uid"])
        )
      : null;
  };

  render() {
    const menu = this.generateMenu();
    const {
      menus: { menus: { entities: menus } },
      menusTranslations: { menusTranslations: { entities: menusTranslations } },
      locales: { locales: { defaultLocale } },
      params: { placeholder }
    } = this.props;
    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">
                {menus.getIn([
                  placeholder,
                  "menuTranslations",
                  defaultLocale,
                  "name"
                ])}
                <div className="subtitle">
                  Kliknij i przeciągnij aby ułożyć elementy menu
                </div>
              </div>
              <div className="content-wrapper">{menu}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/menu/menu.react.js